(function () {
  var variants = window.__productVariants || [];
  var strings = window.__productStrings || { addToCart: 'Add To Cart', soldOut: 'Sold out' };
  var form = document.getElementById('ProductForm');
  if (!form || !variants.length) return;

  var optionRows = form.querySelectorAll('.option-row[data-option-index]');
  var variantIdInput = document.getElementById('ProductVariantId');
  var priceEl = document.getElementById('ProductPrice');
  var addBtn = document.getElementById('ProductAddButton');
  var addBtnText = document.getElementById('ProductAddButtonText');
  var mainImage = document.getElementById('ProductMainImage');
  var thumbs = document.querySelectorAll('.product-thumb');
  var customizationFields = document.getElementById('CustomizationFields');
  var customNameInput = document.getElementById('CustomName');
  var customNumberInput = document.getElementById('CustomNumber');

  var CURRENCY_FORMAT = {
    SEK: { locale: 'sv-SE', symbol: ' kr', position: 'after' },
    NOK: { locale: 'nb-NO', symbol: ' kr', position: 'after' },
    EUR: { locale: 'de-DE', symbol: ' €', position: 'after' },
    GBP: { locale: 'en-GB', symbol: '£', position: 'before' },
    USD: { locale: 'en-US', symbol: '$', position: 'before' }
  };

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK';
    var fmt = CURRENCY_FORMAT[currency] || CURRENCY_FORMAT.SEK;
    var amount = cents / 100;
    var formatted = amount.toLocaleString(fmt.locale, { minimumFractionDigits: 2 }).replace(/[.,]00$/, '');

    return fmt.position === 'before' ? fmt.symbol + formatted : formatted + fmt.symbol;
  }

  function currentSelection() {
    var selected = [];
    optionRows.forEach(function (row) {
      var active = row.querySelector('.option-btn.is-active');
      selected.push(active ? active.getAttribute('data-option-value') : null);
    });
    return selected;
  }

  function findVariant(selection) {
    return variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return selection.every(function (val, i) { return val === null || opts[i] === val; });
    });
  }

  function updateUI() {
    var selection = currentSelection();
    var match = findVariant(selection);
    if (!match) return;

    variantIdInput.value = match.id;

    if (priceEl) {
      var compareHtml = (match.compare_at_price && match.compare_at_price > match.price)
        ? ' <span class="product-price-compare">' + money(match.compare_at_price) + '</span>' : '';
      priceEl.innerHTML = money(match.price) + compareHtml;
    }

    if (match.featured_image && match.featured_image.src && mainImage) {
      mainImage.src = match.featured_image.src;
    }

    if (addBtn) {
      addBtn.disabled = !match.available;
      addBtnText.textContent = match.available ? strings.addToCart : strings.soldOut;
    }
  }

  function toggleCustomizationFields() {
    var customizationRow = form.querySelector('.option-row[data-customization-option="true"]');
    var isCustomized = false;

    if (customizationRow) {
      var active = customizationRow.querySelector('.option-btn.is-active');
      isCustomized = !!active && active.getAttribute('data-customization-state') === 'on';
    }

    if (customizationFields) {
      customizationFields.style.display = isCustomized ? 'flex' : 'none';
      if (!isCustomized) {
        customNameInput.value = '';
        customNumberInput.value = '';
      }
    }
  }

  optionRows.forEach(function (row) {
    row.querySelectorAll('.option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        row.querySelectorAll('.option-btn').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        updateUI();
        toggleCustomizationFields();
      });
    });
  });

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImage) mainImage.src = thumb.getAttribute('data-full-image');
    });
  });

  toggleCustomizationFields();
})();